import { render, staticRenderFns } from "./DsPasswordInput.vue?vue&type=template&id=6d5d1f30&scoped=true&"
import script from "./DsPasswordInput.vue?vue&type=script&lang=js&"
export * from "./DsPasswordInput.vue?vue&type=script&lang=js&"
import style0 from "./DsPasswordInput.vue?vue&type=style&index=0&id=6d5d1f30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5d1f30",
  null
  
)

export default component.exports